import {
    MATERIAL_SUMMARY_FROM_DATE_ELEMENT_ID,
    MATERIAL_SUMMARY_REPORT_DATE_ELEMENT_ID,
    MATERIAL_SUMMARY_TO_DATE_ELEMENT_ID,
} from '../constants/material-summary.constants';
import type { MaterialSummaryPayload } from '../models/material-summary.model';
import { validateMaterialSummaryFilter } from './validate-material-summary-filter.util';

const MATERIAL_SUMMARY_DATE_FIELD_IDS = [
    MATERIAL_SUMMARY_REPORT_DATE_ELEMENT_ID,
    MATERIAL_SUMMARY_FROM_DATE_ELEMENT_ID,
    MATERIAL_SUMMARY_TO_DATE_ELEMENT_ID,
] as const;

/**
 * Validates the Get-Material-Summary Activity Handler request before POST.
 */
export function validateMaterialSummaryPayloadRequest(
    payload: MaterialSummaryPayload
): { ok: true } | { ok: false; message: string; invalidElementIds: readonly string[] } {
    const filter = payload.data?.filter;
    if (!filter) {
        return {
            ok: false,
            message: 'No filters were provided for Material Summary.',
            invalidElementIds: [...MATERIAL_SUMMARY_DATE_FIELD_IDS],
        };
    }

    const v = validateMaterialSummaryFilter(filter);
    if (!v.ok) {
        return v;
    }

    return { ok: true };
}
